import { render, staticRenderFns } from "./MovementTab.vue?vue&type=template&id=9c55dc7c&"
import script from "./MovementTab.vue?vue&type=script&lang=js&"
export * from "./MovementTab.vue?vue&type=script&lang=js&"
import style0 from "./MovementTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports